
import ApplicationController from '../application_controller.js';
import { Controller } from "stimulus";
import { Janus } from 'janus-gateway';

export default class extends ApplicationController {

  initialize() {
    if (!document.keydownListenerAdded) {
      document.addEventListener("keydown", this.keydown.bind(this));
      document.keydownListenerAdded = true;
    }

    // Check if we're in simulation mode
    this.simulationMode = this.element.getAttribute('data-simulation_mode') === 'true';
  }

  connect() {
    let self = this;
    super.connect();

  }

  keydown(event) {
    // Handles key commands for the live call
    //console.warn("Keydown event", event.key);

    //Show debug window on alt+d key press
    if (event.altKey && event.code === 'KeyD') {
      this.showDebug();
    }
  }

  showDebug() {

    let debugElement = document.getElementById("debug");
    if (debugElement.classList.contains("d-none")) {
      debugElement.classList.remove("d-none");
      debugElement.classList.add("d-block");
    } else {
      debugElement.classList.remove("d-block");
      debugElement.classList.add("d-none");
    }
  }

  stopMyVideo() {
    if (this.simulationMode) {
      // In simulation mode, toggle video visibility via reflex
      const contactId = parseInt(this.element.getAttribute('data-my_contact_id'), 10);
      this.stimulate('LiveCallReflex#hide_video', contactId);
    } else {
      document.dispatchEvent(new Event('unpublishMyVideo'));
    }
  }

  executeMute() {
       // Your JavaScript code here
       console.log("Running some JavaScript before muting...");

       // Then invoke the Reflex manually
       this.stimulate('LiveCallReflex#mute')
  }



  startMyVideo() {
    if (this.simulationMode) {
      // In simulation mode, toggle video visibility via reflex
      const contactId = parseInt(this.element.getAttribute('data-my_contact_id'), 10);
      this.stimulate('LiveCallReflex#show_video', contactId);
    } else {
      document.dispatchEvent(new Event('publishMyVideo'));
    }
  }

  // Screen sharing (live mode). Simulated shares use the LiveCall#simulate_screenshare
  // reflex directly from the button. The webrtc controller owns the Janus handle
  // and listens for these events.
  startScreenshare(event) {
    this.markScreenshareBusy(event);
    document.dispatchEvent(new Event('startScreenshare'));
  }

  stopScreenshare(event) {
    this.markScreenshareBusy(event);
    document.dispatchEvent(new Event('stopScreenshare'));
  }

  // Show a spinner until the reflex morphs in the new button state. If the user
  // cancels the browser picker, the webrtc controller dispatches
  // screenshareIdle and we restore the button.
  markScreenshareBusy(event) {
    const button = event?.currentTarget;
    if (!button) return;
    button.disabled = true;
    button.classList.add('busy');
    const icon = button.querySelector('i');
    if (icon) {
      button.dataset.originalIcon = icon.className;
      icon.className = 'bi bi-arrow-repeat';
    }

    const restore = () => {
      button.disabled = false;
      button.classList.remove('busy');
      if (icon && button.dataset.originalIcon) icon.className = button.dataset.originalIcon;
    };
    document.addEventListener('screenshareIdle', restore, { once: true });
  }


}


